import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { INCIDENT_API } from "./apiRoutes";

interface UseGetIncidentCommentHistoryProps {
  id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentCommentHistory = async (id: string, communityId: string) =>
  await axiosAuth.get(`${INCIDENT_API(communityId)}/comments/history/${id}`);

const useGetIncidentCommentHistory = ({
  queryParams,
  id,
  communityId
}: UseGetIncidentCommentHistoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-comment-history", id],
    queryFn: () => getIncidentCommentHistory(id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!id || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetIncidentCommentHistory;
